/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const recentVideoItemSchema = z.object({
  id: z.number(),
  challengeId: z.number(),
  slug: z.string(),
  phrase: z.string(),
  videoUrl: z.string().nullable(),
  posterUrl: z.string().nullable(),
  createdAt: z.number(),
});

export type IRecentSocialVideoItem = z.infer<typeof recentVideoItemSchema>;

const recentDataSchema = z.object({
  items: z.array(recentVideoItemSchema),
});

export interface IListSocialVideosRecentV1Data {
  items: IRecentSocialVideoItem[];
}

export const listSocialVideosRecentV1ResponseSchema = createApiResponseSchema(
  recentDataSchema,
) as z.ZodSchema<IAPI<IListSocialVideosRecentV1Data>>;

export type IListSocialVideosRecentV1Response = IAPI<IListSocialVideosRecentV1Data>;
